const state = {
    currentProduct: null,
    currentVariant: null,
    loaded: false,
};
const mutations = {
    setCurrentProduct(state, product) {
        state.currentProduct = product;
    },
    setCurrentVariant(state, variant) {
        state.currentVariant = variant;
    },
    setRate(state, rate) {
        state.currentProduct ? { ...state.currentProduct, rate } : null;
    },
};
const actions = {
    setCurrentVariant({ commit, state }, variant) {
        commit('setCurrentVariant', variant);
        let newUrl = `${window.location.origin}/product/${state.currentProduct?.slug}/${variant?.slug}`;
        window.history.pushState({}, '', newUrl);
    },
};
const getters = {
    currentProductVariants(state) {
        return state.currentProduct ? state.currentProduct.variants : null;
    },
};
export const productModule = {
    state,
    mutations,
    actions,
    namespaced: true,
    getters,
};
